(function () {
    'use strict';
    function getSliderSettings() {
      return {
        rows: 0,
        dots: false,
        arrows: true,
        prevArrow:`<button type="button" aria-label="previous products" class="slick-arrow slick-prev" style="display: flex;" aria-disabled="false"><img width="19" height="19" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/left-arrow.svg?v=1726055837" alt="Previous Arrow" style="cursor:pointer;"><span class="screen-reader-only">Previous</span></button>`,
        nextArrow:`<button type="button" aria-label="next products" class="slick-arrow slick-next" style="display: flex;" aria-disabled="false"><img width="19" height="19" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481" alt="Next Arrow" style="cursor:pointer;"><span class="screen-reader-only">Next</span></button>`,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        mobileFirst: true,
        responsive: [
          { breakpoint: 1500, settings: { slidesToShow: 5, slidesToScroll: 5 } },
          { breakpoint: 1300, settings: { slidesToShow: 4, slidesToScroll: 4 } },
          { breakpoint: 991,  settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 600,  settings: { slidesToShow: 2.5, slidesToScroll: 2 } },
          { breakpoint: 0,    settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
        ],
      };
    }
  
    function initSlider($slider) {
      if (!$slider || !$slider.length) return;
  
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
        return;
      }
  
      if (window._theme && typeof window._theme.initSlickSlider === 'function') {
        window._theme.initSlickSlider($slider, getSliderSettings());
        return;
      }
  
      if (typeof $slider.slick === 'function') {
        $slider.slick(getSliderSettings());
      }
    }
  
    class HomeFeaturedTabbedSlider extends HTMLElement {
      constructor() {
        super();
        this._onTabClick = this._onTabClick.bind(this);
        this._onKeydown  = this._onKeydown.bind(this);
      }
  
      connectedCallback() {
        this.tabs   = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
  
        this.tabs.forEach((tab) => {
          tab.addEventListener('click',   this._onTabClick);
          tab.addEventListener('keydown', this._onKeydown);
        });
  
        const activeTab = this.tabs.find((t) => t.classList.contains('is-active'));
        if (activeTab) this._applyBg(activeTab);
  
        const activePanel = this.querySelector('.home-tabbed-featured__panel.is-active');
        if (activePanel) this._initSliderInPanel(activePanel);
      }
  
      disconnectedCallback() {
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click',   this._onTabClick);
          tab.removeEventListener('keydown', this._onKeydown);
        });
      }
  
      _onTabClick(e) {
        this._switchTab(e.currentTarget);
      }
  
      _onKeydown(e) {
        const idx = this.tabs.indexOf(e.currentTarget);
        const last = this.tabs.length - 1;
        let next = null;
  
        switch (e.key) {
          case 'ArrowLeft': next = idx === 0    ? last  : idx - 1; break;
          case 'ArrowRight':next = idx === last  ? 0     : idx + 1; break;
          case 'Home':      next = 0;                               break;
          case 'End':       next = last;                            break;
        }
  
        if (next !== null) {
          e.preventDefault();
          this._switchTab(this.tabs[next]);
        }
      }
  
  
      _switchTab(newTab) {
        const targetId = newTab.getAttribute('aria-controls') || newTab.getAttribute('data-home-tab-target');
        if (!targetId) return;
  
        const newPanel = this.querySelector('#' + targetId);
        if (!newPanel) return;
  
        // Deactivate all
        this.tabs.forEach((tab) => {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
        });
        this.panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });
  
        // Activate selected
        newTab.classList.add('is-active');
        newTab.setAttribute('aria-selected', 'true');
        newTab.setAttribute('tabindex', '0');
        newTab.focus();
  
        newPanel.classList.add('is-active');
        newPanel.hidden = false;
  
        this._applyBg(newTab);
        this._initSliderInPanel(newPanel);
      }
  
      _applyBg(tab) {
        const bg = tab.getAttribute('data-panel-bg');
        if (bg) this.style.background = bg;
      }
  
      _initSliderInPanel(panel) {
        if (!window.jQuery) return;
        const $slider = window.jQuery(panel).find('[data-home-tab-slider]');
        if ($slider.length) initSlider($slider);
      }
    }
  
    if (!customElements.get('home-featured-tabbed-slider')) {
      customElements.define('home-featured-tabbed-slider', HomeFeaturedTabbedSlider);
    }
  
    /* ── Global initializer hook (for external callers) ────────────────── */
  
    function initSlidersIn(root) {
      if (!window.jQuery || !root) return;
      const $sliders = window.jQuery(root).find('[data-home-tab-slider]');
      $sliders.each(function () { initSlider(window.jQuery(this)); });
    }
  
    window._homeFeaturedTabSlider = window._homeFeaturedTabSlider || {};
    window._homeFeaturedTabSlider.initSlidersIn = initSlidersIn;
  })();